export interface SystemCheckRequest {
  _checkSequence: boolean
}

export function SystemCheckRequestToJSON(value: SystemCheckRequest): any {
  return {
    _check_sequence: value._checkSequence ?? undefined
  }
}
